import React, { Fragment, useEffect, useState } from 'react'
import { Location } from '@reach/router'
import { pageview } from 'react-ga'
import styled from 'styled-components'
import { hot } from 'react-hot-loader'
import { node } from 'prop-types'
import Head from '../../components/Head/index.js'
import Container from '../../components/Container/Container'
import Header from '../../components/Header/Header'
import ModalErro from '../../components/ModalErro/ModalErro'
import Rotas from '../../rotas.js'
import GlobalStyle from '../../assets/styles/GlobalStyle.js'
import { useGlobal } from '../../contexts/GlobalContext'
import { empty } from '../../utils/helpers/helpers'
import { OpcionaisProvider } from '../../contexts/OpcionaisContext'
import ModalMgm from '../../components/ModalMgm/ModalMgm'
import { MaintenanceView } from '../../components/MaintenanceView/MaintenanceView.js'
import { URLS } from '../../constants'
import { temBooksterNoToken } from '../../utils/helpers/helpersToken'

const WrapperApp = styled.div`
  .routes {
    height: 100%;
  }
`

export function App() {
  const {
    erroRequisicao,
    fetchShouldShowSetup,
    getDadosGlobaisAssociado,
    isAssociadoLogado,
    setDadosGlobaisAssociado,
    setErroRequisicao,
    dadosGlobaisAssociado,
    showModalMgmAtHome,
    setShowModalMgmAtHome,
    verifyAtMaintenance,
    atMaintenance,
  } = useGlobal()
  const [ maintenanceVerified, setMaintenanceVerified ] = useState( false )

  useEffect( () => {
    if ( !isAssociadoLogado ) {
      setDadosGlobaisAssociado( null )
      return
    }

    const isRotaBookster = window.location.pathname.split( '/' ).includes( URLS.BOOKSTER )
    if ( !( isRotaBookster && temBooksterNoToken() ) ) {
      fetchShouldShowSetup()
      getDadosGlobaisAssociado()
    }
  }, [ isAssociadoLogado ] )

  useEffect( () => {
    const url = `${window.location.pathname}${window.location.search}${window.location.hash}`
    pageview( url )
  }, [ window.location.hash, window.location.pathname, window.location.search ] )

  useEffect( () => {
    verifyAtMaintenance()
    setMaintenanceVerified( true )
  }, [] )

  if ( !maintenanceVerified ) {
    return null
  }

  if ( atMaintenance ) {
    return <MaintenanceView />
  }

  return (
    <Fragment>
      <GlobalStyle isAssociadoLogado={ isAssociadoLogado } />

      <Head
        defaultTitle="Área do Associado"
        titleTemplate="%s - Área do Associado"
      />

      <Location>
        { ( { location } ) => {
          if ( location.pathname.split( '/' ).includes( URLS.BOOKSTER ) ) {
            return (
              <main>
                <Rotas className="routes" />
              </main>
            )
          }

          return (
            <Fragment>
              {!empty( erroRequisicao ) && (
                <ModalErro
                  bottomMessage={ erroRequisicao.bottomMessage }
                  descricao={ erroRequisicao.descricao }
                  showModal={ !empty( erroRequisicao ) }
                  titulo={ erroRequisicao.titulo }
                  toggleModal={ () => setErroRequisicao( null ) }
                />
              )}

              { dadosGlobaisAssociado?.associado ?
                <OpcionaisProvider>
                  <ModalMgm
                    codigoIndicacao={ dadosGlobaisAssociado.associado.codigoIndicacao }
                    showModal={ showModalMgmAtHome }
                    toggleModal={ () => setShowModalMgmAtHome( !showModalMgmAtHome ) }
                  />
                </OpcionaisProvider>
                : null }

              <Header headerInterno={ isAssociadoLogado } />

              <main>
                <Container isAssociadoLogado={ isAssociadoLogado }>
                  <WrapperApp>
                    <Rotas className="routes" />
                  </WrapperApp>
                </Container>
              </main>
            </Fragment>
          )
        } }
      </Location>
    </Fragment>
  )
}

App.propTypes = {
  'children': node
}

App.defaultProps = {
  'children': null
}

export default hot( module )( App )
